import React, { useState, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import axios from 'axios';
import HomePage from './HomePage';
import ProductPage from './ProductPage';
import StreamPlayer from './StreamPlayer';
import TopBar from './TopBar';
import BottomBar from './BottomBar';
import { CircularProgress, Box } from '@mui/material';

const App = () => {
  const [langCode, setLangCode] = useState('');
  const [category, setCategory] = useState('');
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      if (!langCode || !category) return;

      try {
        setLoading(true);
        setError(null);
        const url = `https://notedin.onrender.com/api/datastream/?lang_code=${langCode}`;
        const res = await axios.get(url);

        const filteredProducts = res.data?.data.filter(
          (product) => product.product_main_category === category
        );

        setProductList(Array.isArray(filteredProducts) ? filteredProducts : []);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Failed to load products.');
        setProductList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [langCode, category]);

  return (
    <div>
      <TopBar
        langCode={langCode}
        setLangCode={setLangCode}
        category={category}
        setCategory={setCategory}
      />

      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
          <CircularProgress />
        </Box>
      )}

      {error && (
        <Box sx={{ textAlign: 'center', color: 'red', marginTop: 2 }}>
          <p>{error}</p>
        </Box>
      )}

      {!loading && !error && (
        <Routes>
          <Route path="/stream/:productEan" element={<StreamPlayer />} />
          <Route path="/product/:productEan" element={<ProductPage productList={productList} langCode={langCode} />} />
          <Route path="/:ean" element={<ProductPage productList={productList} langCode={langCode} />} />
          <Route path="/" element={<HomePage productList={productList} loading={loading} error={error} />} />
        </Routes>
      )}

      <BottomBar />
    </div>
  );
};

export default App;
